export let baseMenuItems = [
    {
        text: 'Dashboard',
        icon: 'icon-home4',
        routeName: 'Dashboard',
    },

    {
        text: 'Messages',
        icon: 'icon-envelope',
        routeName: 'Messages',
    },

    // {
    //     text: 'Mailing',
    //     icon: 'icon-envelope',
    //     routeName: 'Mailing',
    // },
    // {
    //     text: 'Bids',
    //     icon: 'icon-add-to-list ',
    //     routeName: 'Bids',
    // },

];

export let adminMenu = [
    // {
    //     text: 'Bids',
    //     icon: 'icon-add-to-list ',
    //     routeName: 'Bids',
    // },
    {
        text: 'Clients',
        icon: 'icon-person',
        routeName: 'Clients',
    },
    {
        text: 'System Users',
        icon: 'icon-person',
        routeName: 'SystemClients',
    },
    {
        text: 'Writers',
        icon: 'icon-person',
        routeName: 'Writers',
    },
    {
        text: 'Editors',
        icon: 'icon-person',
        routeName: 'Editors',
    },
    {
        text: 'Sites',
        icon: 'icon-stack',
        routeName: 'Sites',
    },
    // {
    //     text: 'Online Users',
    //     icon: 'icon-person',
    //     routeName: 'Profile',
    // },

    {
        text: 'Payments',
        icon: 'icon-stack-check',
        routeName: 'Payments',
    },
    {
        text: 'Fines',
        icon: 'icon-stack-minus',
        routeName: 'Fines',
    },
    {
        text: 'Bonus',
        icon: 'icon-stack-plus',
        routeName: 'Bonus',
    },


];

export let setupsMenu = [
    {
        text: 'Connections',
        icon: 'icon-cog3',
        routeName: 'connections',
    },
    {
        text: 'Discounts',
        icon: 'icon-stack-minus',
        routeName: 'discounts',
    },

    // {
    //     text: 'Writer Levels',
    //     icon: 'icon-cog3',
    //     routeName: 'writer-levels',
    // },

    {
        text: 'Writer Preferences',
        icon: 'icon-cog3',
        routeName: 'writer-preferences',
    },

    {
        text: 'Additional Services',
        icon: 'icon-cog3',
        routeName: 'additional-services',
    },

    {
        text: 'File Types',
        icon: 'icon-cog3',
        routeName: 'file-types',
    },
    {
        text: 'Styles',
        icon: 'icon-cog3',
        routeName: 'styles',
    },
    {
        text: 'Academic Levels',
        icon: 'icon-cog3',
        routeName: 'academic-levels',
    },
    {
        text: 'Document Types',
        icon: 'icon-cog3',
        routeName: 'document-types',
    },

    {
        text: 'Language Styles',
        icon: 'icon-cog3',
        routeName: 'language-styles',
    },

    {
        text: 'Subject Areas',
        icon: 'icon-cog3',
        routeName: 'subject-areas',
    },

    {
        text: 'Urgency',
        icon: 'icon-cog3',
        routeName: 'urgency',
    },

    {
        text: 'Spacing',
        icon: 'icon-cog3',
        routeName: 'spacing',
    },
    

    
];


export let reportsMenu = []
export let clientMenu = [
    {
        text: 'Bids',
        icon: 'icon-add-to-list ',
        routeName: 'Bids',
    },
    {
        text: 'Clients',
        icon: 'icon-person',
        routeName: 'Clients',
    },
    {
        text: 'Sites',
        icon: 'icon-stack',
        routeName: 'SystemUserSites',
    },
    // {
    //     text: 'Online Users',
    //     icon: 'icon-person',
    //     routeName: 'Profile',
    // },

    {
        text: 'Payments',
        icon: 'icon-stack-check',
        routeName: 'Payments',
    },
    {
        text: 'Fines',
        icon: 'icon-stack-minus',
        routeName: 'Fines',
    },
    {
        text: 'Bonus',
        icon: 'icon-stack-plus',
        routeName: 'Bonus',
    },

    // {
    //     text: 'Discounts',
    //     icon: 'icon-stack-minus',
    //     routeName: 'Discounts',
    // },


];
export let writerMenu = [
    // {
    //     text: 'My Bids',
    //     icon: 'icon-add-to-list ',
    //     routeName: 'Bids',
    // },
    {
        text: 'Payments',
        icon: 'icon-stack-check ',
        routeName: 'Payments',
    },
    // {
    //     text: 'Payment Balance',
    //     icon: 'icon-stack-check',
    //     routeName: 'Balance',
    // },
    {
        text: 'Fines',
        icon: 'icon-stack-minus',
        routeName: 'Fines',
    },
    {
        text: 'Bonus',
        icon: 'icon-stack-plus',
        routeName: 'Bonus',
    },

];
export let editorMenu = [
    // {
    //     text: 'Bids',
    //     icon: 'icon-add-to-list ',
    //     routeName: 'Bids',
    // },
    // {
    //     text: 'My Earnings',
    //     icon: 'icon-stack-check ',
    //     routeName: 'Profile'
    // },

    {
        text: 'Writers',
        icon: 'icon-person',
        routeName: 'Writers',
    },

    {
        text: 'Writer Levels',
        icon: 'icon-cog3',
        routeName: 'WriterLevels',
    },
    {
        text: 'Writer Preferences',
        icon: 'icon-cog3',
        routeName: 'WriterPreferences',
    },
    {
        text: 'Additional Services',
        icon: 'icon-cog3',
        routeName: 'AdditionalServices',
    },
    {
        text: 'Payments',
        icon: 'icon-stack-check',
        routeName: 'Payments',
    },
    {
        text: 'Fines',
        icon: 'icon-stack-minus',
        routeName: 'Fines',
    },
    {
        text: 'Bonus',
        icon: 'icon-stack-plus',
        routeName: 'Bonus',
    },

    // {
    //     text: 'Payment Balance',
    //     icon: 'icon-stack-check',
    //     routeName: 'Balance',
    // },
];


export let WriterLevels = [

    {
        text: 'Writer Levels',
        icon: 'icon-cog3',
        routeName: 'WriterLevels',
    },

];

// export let actionMenuItems = [
//     {
//         text: 'Place Order',
//         icon: 'icon-add',
//         routeName: 'PlaceOrder',
//     },
// ];
